/* ------------------------------------- DEPENDENCIES -------------------------------------- */
import { Icon } from '@iconify/react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
// import Cards from 'react-credit-cards-2';
// import 'react-credit-cards-2/dist/es/styles-compiled.css';
import './styles.css';

/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Autocomplete, Box, Stack, TextField, Typography } from '@mui/material';

/* ------------------------------------- REACT JS ------------------------------------------ */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import { useEffectAsync } from '../../reactHelper';
import { getItem } from '../../fetch';

/* ------------------------------------- COMPONENTS ---------------------------------------- */
import AddNewCardForm from './AddNewCardForm';
import { useTranslation } from '../../common/LocalizationProvider';

function stringifyExpiryMonth(month, year) {
  return month < 10 ? `0${month}/${year}` : `${month}/${year}`;
}

function brandCard(type) {
  if (type) {
    return type.card.brand;
  }

  return 'visa';
}
function displayRenderOption(props, option, type) {
  return (
    <Box
      key={option.id}
      component="li"
      style={{ fontSize: '0.8rem', fontWeight: 'bold' }}
      sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
      {...props}
    >
      {option.id === 'new' ? (
        <>
          <Icon
            key={option.id}
            icon="mdi:plus"
            width={24}
            height={24}
            style={{ marginLeft: 2, marginRight: 18 }}
          />
          {option.card}
        </>
      ) : (
        <Stack spacing={2} direction="row">
          <Icon icon={`logos:${brandCard(type)}`} width="28" height="28" />
          <Typography variant="subtitle2">XXXX-XXXX-XXXX-{option.card}</Typography>
        </Stack>
      )}
    </Box>
  );
}

export default function SubscriptionInfo() {
  const t = useTranslation();
  const location = useLocation();
  const [paymentMethodRetrieve, setPaymentMethodRetrieve] = useState([]);
  const [selectedCard, setSelectedCard] = useState('0000');
  const selectedCardInfo = paymentMethodRetrieve.find((item) => item.card.last4 === selectedCard);
  const { enqueueSnackbar } = useSnackbar();

  const plan = {
    id: location.state.id,
    name: location.state.name,
    color: location.state.color,
    price: location.state.price
  };

  const options = paymentMethodRetrieve.map((item) => ({
    id: item.id,
    card: item.card.last4
  }));

  const handleAutoCompleteChange = (value) => {
    if (value === null || value.id === null || value.card === null) {
      setSelectedCard('0000');
      location.state = { ...location.state, paymentMethodID: null };
    } else if (value.id === 'new') {
      setSelectedCard('new');
      location.state = { ...location.state, paymentMethodID: null };
    } else {
      setSelectedCard(value.card);
      location.state = { ...location.state, paymentMethodID: value.id };
    }
  };

  useEffectAsync(async () => {
    const response = await getItem('abonnement/payment-method');
    if (response.ok) {
      setPaymentMethodRetrieve(await response.json());
    } else {
      const message = await response.text();
      enqueueSnackbar(message.slice(0, message.indexOf('-')), { variant: 'error' });
    }
  }, []);

  return (
    <Stack spacing={3} direction="column">
      <Typography variant="h6" gutterBottom>
        {t('SPA_PaymentInfo')}
      </Typography>

      {plan.id !== 'free' ? (
        <Autocomplete
          options={[...options, { id: 'new', card: t('addNewCard') }]}
          autoHighlight
          getOptionLabel={(option) =>
            option.id === 'new' ? '' : `${t('ANC_CardEndingIn')} ${option.card}`
          }
          onChange={(event, value) => handleAutoCompleteChange(value)}
          renderOption={(props, option) =>
            displayRenderOption(
              props,
              option,
              paymentMethodRetrieve.find((item) => item.card.last4 === option.card)
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                selectedCard === '0000' || selectedCard === 'new'
                  ? t('ANC_ChooseCard')
                  : `${t('ANC_CardEndingIn')} ${selectedCard}`
              }
              inputProps={{
                ...params.inputProps
              }}
            />
          )}
        />
      ) : (
        <Stack>
          <Autocomplete
            disabled
            options={[...options]}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('ANC_NoCreditCard')}
                inputProps={{
                  ...params.inputProps
                }}
              />
            )}
          />
        </Stack>
      )}

      {selectedCard === 'new' && (
        <AddNewCardForm
          handleChangeSelectedCard={(value) => {
            if (value.id !== undefined && value.id !== null && value.id.length !== 0) {
              location.state = { ...location.state, paymentMethodID: value.id };
              setPaymentMethodRetrieve([...paymentMethodRetrieve, value]);
              setSelectedCard(value.card.last4);
            } else {
              setSelectedCard('0000');
              enqueueSnackbar(t('SPA_Error'), { variant: 'error' });
            }
          }}
        />
      )}

      {paymentMethodRetrieve.length > 0 &&
        selectedCard !== '0000' &&
        selectedCard !== 'new' &&
        selectedCardInfo !== undefined && (
          <Cards
            expiry={
              selectedCardInfo.card.expMonth || selectedCardInfo.card.expYear
                ? stringifyExpiryMonth(
                    selectedCardInfo.card.expMonth,
                    selectedCardInfo.card.expYear
                  )
                : stringifyExpiryMonth(
                    selectedCardInfo.card.exp_month,
                    selectedCardInfo.card.exp_year
                  )
            }
            focused="name"
            name={selectedCardInfo.card.brand}
            number={`000000000000${selectedCardInfo.card.last4}`}
            cvc="Null"
          />
        )}
    </Stack>
  );
}
